import React, { FC, useState } from "react";
import { getThemeColors, Theme } from "../theme/colors";
import { useMediaQuery } from "react-responsive";

interface FollowUpSuggestionsProps {
  suggestions: string[];
  theme: Theme;
  username: string;
  onSuggestionClick: (suggestion: string) => void;
  isDisabled?: boolean;
}

const FollowUpSuggestions: FC<FollowUpSuggestionsProps> = ({
  suggestions,
  theme,
  username,
  onSuggestionClick,
  isDisabled = false,
}) => {
  const colors = getThemeColors(username, theme);
  const isTablet = useMediaQuery({ maxWidth: 810 });
  const isMobile = useMediaQuery({ maxWidth: 414 });
  const [selectedSuggestion, setSelectedSuggestion] = useState<string | null>(null);

  // Don't render if no suggestions
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  const handleSuggestionClick = (suggestion: string) => {
    if (!isDisabled) {
      setSelectedSuggestion(suggestion);
      onSuggestionClick(suggestion);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        marginBottom: "15px",
        marginTop: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: "8px",
          flexWrap: "wrap",
        }}
      >
        {suggestions.map((suggestion, index) => {
          const isSelected = selectedSuggestion === suggestion;
          
          return (
            <button
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              disabled={isDisabled}
              style={{
                padding: "8px 12px",
                border: `1px solid ${colors.border}`,
                borderRadius: "16px",
                backgroundColor: isDisabled 
                  ? (isSelected ? colors.convoStarterHover : colors.disabledPlaceholder)
                  : isSelected 
                    ? colors.convoStarterHover 
                    : colors.convoStarterBg,
                color: colors.text,
                cursor: isDisabled ? "not-allowed" : "pointer",
                fontSize: "13px",
                textAlign: "left",
                wordWrap: "break-word",
                opacity: isDisabled ? (isSelected ? 0.8 : 0.6) : 1,
                transition: "background-color 0.2s ease",
                flex: isMobile ? "1" : "0 1 auto",
                maxWidth: isMobile ? "100%" : "100%",
                whiteSpace: "normal",
              }}
              onMouseEnter={(e) => {
                if (!isDisabled && !isSelected) {
                  e.currentTarget.style.backgroundColor = colors.convoStarterHover;
                }
              }}
              onMouseLeave={(e) => {
                if (!isDisabled && !isSelected) {
                  e.currentTarget.style.backgroundColor = colors.convoStarterBg;
                }
              }}
            >
              {suggestion}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FollowUpSuggestions;
